import { APP_BASE_URL, PROFFIT_SEARCH_COLUMN_EXTERNAL_PATH } from '../env';
export const s3StaticPath = 'https://proffit.s3-ap-northeast-1.amazonaws.com/upload/static';
export const PRO_PDF_URL = 'https://contents.proffit.jp/hubfs/proffit_service_consultant.pdf';
export const CLIENT_PDF_URL = 'https://contents.proffit.jp/hubfs/proffit_service-1.pdf';
/** 提供するサービス: 案件開拓/提案機会提供支援 */
export const PRO_TOP_OFFER_SERVICE_PROPOSAL_SUPPORT = 'https://contents.proffit.jp/hubfs/%E3%82%B3%E3%83%B3%E3%82%B5%E3%83%ABTOP/Consultant-teiankikaiteikyou-2306.pdf';
/** 提供するサービス: アドバイザリー支援の機会提供 */
export const PRO_TOP_OFFER_SERVICE_ADVISORY_SUPPORT = 'https://contents.proffit.jp/hubfs/%E3%82%B3%E3%83%B3%E3%82%B5%E3%83%ABTOP/Consultant-leadteikyou-2306.pdf';
/** 提供するサービス: 若手特化型のコンサル採用支援 */
export const PRO_TOP_OFFER_SERVICE_RECRUITMENT_SUPPORT = 'https://contents.proffit.jp/hubfs/%E3%82%B3%E3%83%B3%E3%82%B5%E3%83%ABTOP/Consultant-service-2306.pdf';
/** 提供するサービス: コンサル実践力テスト・育成促進支援 */
export const PRO_TOP_OFFER_SERVICE_GROWING_SUPPORT = 'https://contents.proffit.jp/hubfs/%E3%82%B3%E3%83%B3%E3%82%B5%E3%83%ABTOP/Consultant-ikuseishien-2306.pdf';
export const LANDING_PAGE_KEY_VISUAL_BG_IMAGE_URL = `${s3StaticPath}/lp/top/kv_client.jpg`;
export const PROFESSIONAL_LANDING_PAGE_KEY_VISUAL_BG_IMAGE_URL = `${s3StaticPath}/lp/for_consultant/kv_consul.jpg`;
export const PRO_RFP_REPLACE_PDF = `${s3StaticPath}/%E3%80%90Proffit%E3%80%91%E6%8F%90%E6%A1%88%E6%8F%90%E5%87%BA%E3%81%AB%E3%81%8A%E3%81%91%E3%82%8BWeb%E3%82%B5%E3%82%A4%E3%83%88%E6%93%8D%E4%BD%9C%E6%96%B9%E6%B3%95%E5%A4%89%E6%9B%B4%E3%81%AE%E3%81%93%E3%82%99%E6%A1%88%E5%86%85.pdf`;
/** コンサルタント：2022/06/01 提案機能と料金プラン変更の告知資料 */
export const PROFESSIONAL_RFP_REPLACE_V2_PDF_URL = 'https://contents.proffit.jp/hubfs/update.pdf';
/** クライアント：2022/06/01 提案募集の機能追加 */
export const CLIENT_RFP_REPLACE_PDF_URL = 'https://contents.proffit.jp/hubfs/update_220524.pdf';
/** コンサルタント: ホットライン資料リンク */
export const PROFESSIONAL_HOTLINE_DESCRIPTION_PDF_URL = 'https://contents.proffit.jp/hubfs/hotline_forCONSULTANT.pdf';
/** コンサルタント: MART 説明資料リンク */
export const PROFESSIONAL_MART_DESCRIPTION_PDF_URL = 'https://contents.proffit.jp/hubfs/MART%E7%B4%B9%E4%BB%8B%E8%B3%87%E6%96%99_202501%E7%89%88.pdf';
// TODO: あとでコラムのURLとタイトルを正しい内容に書き換える
export const PROFFIT_SEARCH_COLUMN_TITLE = '5分でわかる！\nスライドサーチ活用法';
export const PROFFIT_SEARCH_COLUMN_EXTERNAL_URL = `${APP_BASE_URL}${PROFFIT_SEARCH_COLUMN_EXTERNAL_PATH}`;
export const PROFFIT_SEARCH_COLUMN_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/kv-column.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_KEY_VISUAL_BG_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/lp-bg.jpg`;
export const PROFFIT_SEARCH_LANDING_PAGE_KEY_VISUAL_CIRCLE_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/kv-circle.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_KEY_VISUAL_MAIN_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/kv-image.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_BEFORE_AFTER_BEFORE_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/before.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_BEFORE_AFTER_AFTER_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/after.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_STEPS_STEP_1_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/step1.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_STEPS_STEP_2_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/step2.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_STEPS_STEP_3_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/step3.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_TEAM_MAN_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/team-man.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_TEAM_SHARE_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/team-share.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_TEAM_ARROW_RIGHT_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/team-arrow-right.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_TEAM_ARROW_LEFT_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/team-arrow-left.png`;
export const PROFFIT_SEARCH_LANDING_PAGE_SECURITY_BG_IMAGE_URL = `${s3StaticPath}/lp/proffit_search/security-bg.jpg`;
export const PROFFIT_SEARCH_MY_PAGE_MAIN_BANNER_PC = `${s3StaticPath}/lp/proffit_search/mypage-main-banner-pc.png`;
export const PROFFIT_SEARCH_MY_PAGE_MAIN_BANNER_SP = `${s3StaticPath}/lp/proffit_search/mypage-main-banner-sp.png`;
export const PROFFIT_SEARCH_MY_PAGE_SIDE_BANNER = `${s3StaticPath}/lp/proffit_search/mypage-side-banner.png`;
export const PROFFIT_SEARCH_SEARCH_BG_IMAGE_URL = `${s3StaticPath}/proffit_search/slide_search_bg.png`;
export const PROFFIT_SEARCH_TOP_ASSET = {
    onBoarding1: `${s3StaticPath}/proffit_search/onboarding1.png`,
    onBoarding2: `${s3StaticPath}/proffit_search/onboarding2.png`,
    onBoarding3: `${s3StaticPath}/proffit_search/onboarding3.png`,
    uploadCompleteBg: `${s3StaticPath}/proffit_search/upload_complete_bg.png`,
    uploadCompleteImage: `${s3StaticPath}/proffit_search/upload_complete_image.png`,
    uploadProgressBg: `${s3StaticPath}/proffit_search/upload_progress_bg.png`,
    uploadProgressImage: `${s3StaticPath}/proffit_search/upload_progress_image.png`,
};
export const BLANK_IMAGE_URL = `${s3StaticPath}/ui/img-noimage.png`;
export const BLANK_NO_USER_IMAGE_URL = `${s3StaticPath}/ui/img-noimage-user.png`;
export const UPLOADING_IMAGE_URL = `${s3StaticPath}/ui/img-uploading.png`;
export const SEMINAR_BANNER_IMAGE_URL = `${s3StaticPath}/seminar/banner-seminar.png`;
export const SEMINAR_BANNER_SIDE_PC_IMAGE_URL = `${s3StaticPath}/seminar/banner-seminar-side-pc.png`;
export const SEMINAR_BANNER_TOP_IMAGE_URL = `${s3StaticPath}/seminar/banner-seminar-top_2.png`;
/** サンプルの提案フィードバック資料画像 */
export const RFPS_SAMPLE_REPORT_IMAGE_URL = `${s3StaticPath}/rfps/rfps-sample-report.png`;
/** サンプルの提案フィードバック資料PDF */
export const RFPS_SAMPLE_REPORT_PDF_URL = 'https://contents.proffit.jp/hubfs/sample.pdf';
/** 提案フィードバック申し込みURL */
export const RFPS_SAMPLE_REPORT_REGISTRATION_URL = 'https://share.hsforms.com/1nmxsRe1AThGCPgCGVK99wg3pxyp';
/** 案件事例紹介イメージ画像（カテゴリー）: 調査・分析 */
export const CASE_IMAGE_CATEGORY_RESEARCH = {
    base: `${s3StaticPath}/case/case_research.jpg`,
    webp: `${s3StaticPath}/case/case_research.webp`,
};
/** 案件事例紹介イメージ画像（カテゴリー）: 事業戦略 */
export const CASE_IMAGE_CATEGORY_BUSINESS_STRATEGY = {
    base: `${s3StaticPath}/case/case_business_strategy.jpg`,
    webp: `${s3StaticPath}/case/case_business_strategy.webp`,
};
/** 案件事例紹介イメージ画像（カテゴリー）: IT・デジタル */
export const CASE_IMAGE_CATEGORY_IT_DIGITAL = {
    base: `${s3StaticPath}/case/case_it_digital.jpg`,
    webp: `${s3StaticPath}/case/case_it_digital.webp`,
};
/** 案件事例紹介イメージ画像（カテゴリー）: マーケティング */
export const CASE_IMAGE_CATEGORY_MARKETING = {
    base: `${s3StaticPath}/case/case_marketing.jpg`,
    webp: `${s3StaticPath}/case/case_marketing.webp`,
};
/** 案件事例紹介イメージ画像（カテゴリー）: 営業 */
export const CASE_IMAGE_CATEGORY_SALES = {
    base: `${s3StaticPath}/case/case_sales.jpg`,
    webp: `${s3StaticPath}/case/case_sales.webp`,
};
/** 案件事例紹介イメージ画像（カテゴリー）: 業務改善 */
export const CASE_IMAGE_CATEGORY_BUSINESS_IMPROVEMENT = {
    base: `${s3StaticPath}/case/case_business_improvement.jpg`,
    webp: `${s3StaticPath}/case/case_business_improvement.webp`,
};
/** 案件事例紹介イメージ画像（カテゴリー）: 経営戦略 */
export const CASE_IMAGE_CATEGORY_MANAGEMENT_STRATEGY = {
    base: `${s3StaticPath}/case/case_management_strategy.jpg`,
    webp: `${s3StaticPath}/case/case_management_strategy.webp`,
};
/** 案件事例紹介イメージ画像（カテゴリー）: 新規事業 */
export const CASE_IMAGE_CATEGORY_NEW_BUSINESS = {
    base: `${s3StaticPath}/case/case_new_business.jpg`,
    webp: `${s3StaticPath}/case/case_new_business.webp`,
};
/** 案件事例紹介イメージ画像（カテゴリー）: 人事組織 */
export const CASE_IMAGE_CATEGORY_PERSONNEL_ORGANIZATION = {
    base: `${s3StaticPath}/case/case_personnel_organization.jpg`,
    webp: `${s3StaticPath}/case/case_personnel_organization.webp`,
};
/** 案件事例紹介イメージ画像（カテゴリー）: 調達・生産・物流 */
export const CASE_IMAGE_CATEGORY_PROCUREMENT_LOGISTICS = {
    base: `${s3StaticPath}/case/case_procurement_logistics.jpg`,
    webp: `${s3StaticPath}/case/case_procurement_logistics.webp`,
};
